"use client";

import * as React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { cn } from "@/lib/utils";

const fallbackAutoCols = {
	"2": "lg:auto-cols-[calc((100%-24px)/2.2)]",
	"3": "lg:auto-cols-[calc((100%-48px)/3.2)]",
	"4": "lg:auto-cols-[calc((100%-72px)/4.2)]",
	"5": "lg:auto-cols-[calc((100%-96px)/5.2)]",
};

export function StepsCarousel({ slides, columns }: { slides: React.ReactNode[]; columns: "2" | "3" | "4" | "5" }) {
	const [isSwiperReady, setIsSwiperReady] = React.useState(false);

	return (
		<div className="relative w-full [--steps-gap:24px]">
			{!isSwiperReady && (
				<div className="w-full overflow-hidden">
					<div className={cn("grid grid-flow-col gap-6 auto-cols-[85%] sm:auto-cols-[72%] md:auto-cols-[47%]", fallbackAutoCols[columns])}>
						{slides}
					</div>
				</div>
			)}

			<div className={cn("w-full overflow-hidden", !isSwiperReady && "pointer-events-none absolute inset-0 opacity-0")} aria-hidden={!isSwiperReady}>
				<Swiper
					modules={[Navigation]}
					spaceBetween={24}
					slidesPerView={1.1}
					breakpoints={{
						640: { slidesPerView: 1.3 },
						768: { slidesPerView: 2.3 },
						1024: { slidesPerView: Math.min(parseInt(columns) + 0.2, slides.length) },
					}}
					onAfterInit={() => setIsSwiperReady(true)}
				>
					{slides.map((slide, index) => (
						<SwiperSlide key={index} className="h-auto!">
							{slide}
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
}
